import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { ObservationContext } from "./components/ObservationContext";
import formatDate from "../components/formatDate";
import states from "../../components/states";

const ObservationRightContainer = () => {
  const { observationSelected } = useContext(ObservationContext);

  const getData = (path) => {
    if (!observationSelected) return "No data";
    const value = path
      .split(".")
      .reduce((o, k) => (o || {})[k], observationSelected);
    return value !== undefined && value !== null ? value : "No data";
  };

  const formatValue = (value, unit = "") => {
    if (value === "No data") return value;
    if (typeof value === "number") return `${value.toFixed(3)} ${unit}`.trim();
    return `${value} ${unit}`.trim();
  };

  // get the previous observation with the same type (VHR/HR)
  const getDeltaFrom = () => {
  };

  const getDeltaColor = () => {
    const delta = getData("delta");
    if (delta === "No data") return "inherit";
    return parseFloat(delta) <= 0 ? "green" : "red";
  };

  return (
    <Box className="observation-right-container">
      <Box className="observation-right">
        <Typography
          className="header-info"
          sx={{ fontWeight: "600", marginTop: "20px", marginBottom: "5px" }}
        >
          Observation Info
        </Typography>
        <Typography className="identifier-text" sx={{ fontSize: "14px" }}>
          Identifier: {getData("properties.identifier")}
        </Typography>
        <Typography
          className="identifier-text"
          sx={{ marginBottom: "5px", fontSize: "13px" }}
        >
          Date:{" "}
          {getData("properties.acquisition_info.date") !== "No data"
            ? formatDate(getData("properties.acquisition_info.date"))
            : "No data"}
        </Typography>
        <Box className="details">
          <Typography
            className="details-text"
            sx={{
              fontWeight: "var(--font-semi)",
              marginBottom: "1px",
              fontSize: "13px",
            }}
          >
            Details
          </Typography>
          <Box className="detail-item">
            <Typography component="span" className="label">
              Sensor Label:
            </Typography>{" "}
            <Typography component="span" className="value">
              {getData("properties.sensor_label")}
            </Typography>
          </Box>
          <Box className="detail-item">
            <Typography component="span" className="label">
              Latitude:
            </Typography>{" "}
            <Typography component="span" className="value">
              {formatValue(getData("properties.centroid.coordinates.1"), "°")}
              {getData("properties.centroid.coordinates.1") > 0 ? " North" : " South"}
            </Typography>
          </Box>
          <Box className="detail-item">
            <Typography component="span" className="label">
              Longitude:
            </Typography>{" "}
            <Typography component="span" className="value">
              {formatValue(getData("properties.centroid.coordinates.0"), "°")}
              {getData("properties.centroid.coordinates.1") > 0 ? " East" : " West"}
            </Typography>
          </Box>
          <Box className="detail-item">
            <Typography component="span" className="label">
              Oil Area:
            </Typography>{" "}
            <Typography component="span" className="value">
              {formatValue(getData("properties.area"), "m2")}
            </Typography>
          </Box>
          <Box className="detail-item">
            <Typography component="span" className="label">
              Oil Volume:
            </Typography>{" "}
            <Typography component="span" className="value">
              {formatValue(getData("properties.volume"), "barrels")}
            </Typography>
          </Box>
          <Box className="detail-item">
            <Typography component="span" className="label">
              Polluted sand volume:
            </Typography>{" "}
            <Typography component="span" className="value">
              {getData("properties.polluted_sand_volume")
                ? `${formatValue(
                    getData("properties.polluted_sand_volume")
                  )} m3`
                : "No data"}
            </Typography>
          </Box>
          <Box className="detail-item">
            <Typography component="span" className="label">
              In-Situ Verification:
            </Typography>{" "}
            <Typography component="span" className="value">
              {getData("properties.ISverification") === true
                ? "Yes"
                : getData("properties.ISverification") === false
                ? "No"
                : "No data"}
            </Typography>
          </Box>
          <Box className="detail-item">
            <Typography component="span" className="label">
              In-Situ Actions:
            </Typography>{" "}
            <Typography component="span" className="value">
              {getData("properties.ISactions") === true
                ? "Yes"
                : getData("properties.ISactions") === false
                ? "No"
                : "No data"}
            </Typography>
          </Box>

          <Box className="detail-item">
            <Typography component="span" className="label">
              State:
            </Typography>{" "}
            <Typography component="span" className="value">
              {getData("properties.state") !== "No data"
                ? states[getData("properties.state")]
                : "No data"}
            </Typography>
          </Box>
          <Box className="detail-item">
            <Typography component="span" className="label">
              Delta:
            </Typography>{" "}
            <Typography
              component="span"
              className="value"
              style={{ color: getDeltaColor() }}
            >
              {getDeltaFrom()}
              {formatValue(getData("delta"), "barrels")}
            </Typography>
          </Box>
        </Box>
        <Box className="info-icon">
          <InfoIcon className="icon" fontSize="medium" />
        </Box>
      </Box>
    </Box>
  );
};

export default ObservationRightContainer;
